(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3161],{

/***/ 58451:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/akoestische-panelen/[id]",
      function () {
        return __webpack_require__(46796);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 217:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Calculates the number of spooky skeletons to show while an infinite scroll is loading the next page.
 * Per default we fetch 12 products per page, so we need to calculate the number of skeletons to show,
 * if the remaing products are less than 12.
 */ var getNumberOfSkeletons = function(pages) {
    if (!pages) {
        return 0;
    }
    var count = pages[pages.length - 1].response.count;
    var retrieved = count - pages.reduce(function(acc, curr) {
        return acc + curr.response.products.length;
    }, 0);
    if (count - retrieved < 12) {
        return count - retrieved;
    }
    return 12;
};
/* harmony default export */ __webpack_exports__["Z"] = (getNumberOfSkeletons);


/***/ }),

/***/ 16519:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var sortProductsAdvanced = function(products) {
    return products.sort(function(productA, productB) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        var ref9;
        var measurementA = parseInt((ref9 = (ref1 = productA === null || productA === void 0 ? void 0 : (ref = productA.title) === null || ref === void 0 ? void 0 : ref.match(/\d+/)) === null || ref1 === void 0 ? void 0 : ref1[0]) !== null && ref9 !== void 0 ? ref9 : "400");
        var ref10;
        var measurementB = parseInt((ref10 = (ref3 = productB === null || productB === void 0 ? void 0 : (ref2 = productB.title) === null || ref2 === void 0 ? void 0 : ref2.match(/\d+/)) === null || ref3 === void 0 ? void 0 : ref3[0]) !== null && ref10 !== void 0 ? ref10 : "400");
        if (productA.title.match(/geel|zwart|rustiek|walnoot|ebony|naturel/i) === null || productB.title.match(/geel|zwart|rustiek|walnoot|ebony|naturel/i) === null) return 0;
        var ref11;
        var colorA = (ref11 = (ref6 = (ref5 = productA === null || productA === void 0 ? void 0 : (ref4 = productA.title) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) === null || ref5 === void 0 ? void 0 : ref5.match(/geel|zwart|rustiek|walnoot|ebony|naturel/i)) === null || ref6 === void 0 ? void 0 : ref6[0]) !== null && ref11 !== void 0 ? ref11 : "naturel";
        var ref12;
        var colorB = (ref12 = (ref8 = productB === null || productB === void 0 ? void 0 : (ref7 = productB.title) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase().match(/geel|zwart|rustiek|walnoot|ebony|naturel/i)) === null || ref8 === void 0 ? void 0 : ref8[0]) !== null && ref12 !== void 0 ? ref12 : "naturel";
        var colorValues = {
            rustiek: 0,
            walnoot: 1,
            zwart: 2,
            ebony: 3,
            geel: 4,
            naturel: 5
        };
        if (measurementA < measurementB) {
            return -1;
        } else if (measurementA > measurementB) {
            return 1;
        } else {
            if (colorValues[colorA] < colorValues[colorB]) {
                return -1;
            } else if (colorValues[colorA] > colorValues[colorB]) {
                return 1;
            } else {
                return 0;
            }
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (sortProductsAdvanced);


/***/ }),

/***/ 31660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_util_repeat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61692);
/* harmony import */ var _modules_skeletons_components_skeleton_product_preview__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _modules_common_render_item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41702);





var SkeletonCollectionPage = function(param) {
    var content = param.content;
    var items = content === null || content === void 0 ? void 0 : content.content;
    /*const [firstItem, setFirstItem] = useState<
        HeroProp | OneImageProp | TwoImageProp | FullTextProp
    >()
    const [items, setItems] =
        useState<Array<HeroProp | OneImageProp | TwoImageProp | FullTextProp>>()*/ /*useEffect(() => {
        const items = content?.content
        setFirstItem(items?.shift())
        setItems(items)
    }, [content])*/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "grain-background",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative z-10 grid grid-cols-1 small:grid-cols-6  px-4 py-7 lg:px-12 lg:py-20",
                children: [
                    items && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_render_item__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        item: items[0]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative block col-span-4 small:col-span-1 h-20 bg-gray-100"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-5 small:px-8 transition flex flex-col small:items-start py-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "small:content-container ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                className: "grid grid-cols-2 small:grid-cols-3 medium:grid-cols-4 gap-x-4 gap-y-8",
                                children: (0,_lib_util_repeat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(8).map(function(index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_skeletons_components_skeleton_product_preview__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                                    }, index);
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative z-10 grid grid-cols-1 small:grid-cols-6 px-4 small:px-0 py-7",
                children: items && items.map(function(item, index) {
                    return index === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_render_item__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        item: item
                    });
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute inset-0 z-0 pointer-events-none",
                style: {
                    background: "linear-gradient(\n" + "    to right,\n" + "    transparent 0%,\n" + "    transparent 33.33%,\n" + "    #f6f6f6 33.33%,\n" + "    #f6f6f6 100%\n" + "  )"
                },
                children: "\xa0"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonCollectionPage);


/***/ }),

/***/ 46796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _id_; },
  "fetchCollectionProducts": function() { return /* binding */ fetchCollectionProducts; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/lib/config.ts
var config = __webpack_require__(17590);
// EXTERNAL MODULE: ./src/lib/constants.ts
var constants = __webpack_require__(57469);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/lib/hooks/use-previews.tsx + 1 modules
var use_previews = __webpack_require__(42984);
// EXTERNAL MODULE: ./src/lib/util/get-number-of-skeletons.ts
var get_number_of_skeletons = __webpack_require__(217);
// EXTERNAL MODULE: ./src/lib/util/repeat.ts
var repeat = __webpack_require__(61692);
// EXTERNAL MODULE: ./src/modules/products/components/product-preview/index.tsx + 1 modules
var product_preview = __webpack_require__(84874);
// EXTERNAL MODULE: ./src/modules/skeletons/components/skeleton-product-preview/index.tsx
var skeleton_product_preview = __webpack_require__(15986);
// EXTERNAL MODULE: ./node_modules/medusa-react/dist/medusa-react.esm.js + 1 modules
var medusa_react_esm = __webpack_require__(12863);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/modules/common/render-item/index.tsx
var render_item = __webpack_require__(41702);
// EXTERNAL MODULE: ./src/lib/util/product-advanced-sort.ts
var product_advanced_sort = __webpack_require__(16519);
;// CONCATENATED MODULE: ./src/modules/collections/templates/index.tsx















var CollectionTemplate = function(param) {
    var collection = param.collection, content = param.content;
    var ref = (0,react.useState)({}), params = ref[0], setParams = ref[1];
    var cart = (0,medusa_react_esm/* useCart */.jD1)().cart;
    var items = content === null || content === void 0 ? void 0 : content.content;
    var ref1 = (0,react_intersection_observer_modern/* useInView */.YD)(), ref2 = ref1.ref, inView = ref1.inView;
    var ref3;
    var ref4 = (0,es.useInfiniteQuery)([
        "get_collection_products",
        collection.id,
        cart === null || cart === void 0 ? void 0 : cart.id,
        params.filters
    ], function(param) {
        var pageParam = param.pageParam;
        return fetchCollectionProducts({
            pageParam: pageParam,
            id: collection.id,
            cartId: cart === null || cart === void 0 ? void 0 : cart.id,
            filters: (ref3 = params === null || params === void 0 ? void 0 : params.filters) !== null && ref3 !== void 0 ? ref3 : {}
        });
    }, {
        getNextPageParam: function(lastPage) {
            return lastPage.nextPage;
        }
    }), infiniteData = ref4.data, hasNextPage = ref4.hasNextPage, fetchNextPage = ref4.fetchNextPage, isFetchingNextPage = ref4.isFetchingNextPage, isLoading = ref4.isLoading;
    var previews = (0,use_previews/* default */.Z)({
        pages: infiniteData === null || infiniteData === void 0 ? void 0 : infiniteData.pages,
        region: cart === null || cart === void 0 ? void 0 : cart.region
    });
    /*.map((p) => {
        const reviewData = useQuery(
            [`get_review`, p?.handle, `reviews`],
            () => fetchReviews(p.id),
            {
                enabled: (p?.handle ?? "").length > 0,
                keepPreviousData: true
            }
        )
        const reviews = reviewData.data?.product_reviews ?? []
        if (!reviewData.isSuccess || !reviews.length) return p
        return {
            ...p,
            reviews: {
                average_rating: reviews.reduce(
                    (acc, curr) => acc + curr.rating,
                    0
                ),
                count: reviews.length,
                reviews: reviews
            }
        } as ProductPreviewType
    })*/ (0,react.useEffect)(function() {
        if (inView && hasNextPage) {
            fetchNextPage();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inView,
        hasNextPage
    ]);
    /*useEffect(() => {
        const items = content?.content
        setFirstItem(items?.shift())
        setItems(items)
    }, [content])*/ var hit = [
        2,
        4,
        8
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grain-background",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative z-10 grid grid-cols-1 small:grid-cols-6  px-4 py-7 lg:px-12 lg:py-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative small:absolute z-20 bg-red-600 text-white p-3 small:rounded-full text-[0.8rem] small:text-[19px] small:right-10 small:top-10 text-center w-full md:w-[200px] small:aspect-square flex items-center justify-center",
                        children: [
                            "GRATIS VERZENDING ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            collection.id === "pcol_01GQDXMFP78WHSFFAHB6K4EV79" ? "SAMPLES" : "AKUPANELEN",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "NL & BE"
                        ]
                    }),
                    items && /*#__PURE__*/ (0,jsx_runtime.jsx)(render_item/* default */.Z, {
                        item: items[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-6 small:px-8 transition flex flex-col small:items-start py-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "small:content-container ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "grid grid-cols-2 small:grid-cols-3 medium:grid-cols-4 gap-x-4 gap-y-8",
                                    children: [
                                        (0,product_advanced_sort/* default */.Z)(previews).map(function(p, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_preview/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                                                    doubleColl: false
                                                }))
                                            }, p.id);
                                        }),
                                        isLoading && !previews.length && (0,repeat/* default */.Z)(8).map(function(index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_product_preview/* default */.Z, {})
                                            }, index);
                                        }),
                                        isFetchingNextPage && (0,repeat/* default */.Z)((0,get_number_of_skeletons/* default */.Z)(infiniteData === null || infiniteData === void 0 ? void 0 : infiniteData.pages)).map(function(index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_product_preview/* default */.Z, {})
                                            }, index);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "py-4 small:py-16 flex justify-center items-center text-small-regular text-gray-700",
                                    ref: ref2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        ref: ref2
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative z-10 grid grid-cols-1 small:grid-cols-6 px-4 small:px-0 py-7",
                children: items && items.map(function(item, index) {
                    return index === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(render_item/* default */.Z, {
                        item: item
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 z-0 pointer-events-none",
                style: {
                    background: "linear-gradient(\n" + "    to right,\n" + "    transparent 0%,\n" + "    transparent 33.33%,\n" + "    #f6f6f6 33.33%,\n" + "    #f6f6f6 100%\n" + "  )"
                },
                children: "\xa0"
            })
        ]
    });
};
/* harmony default export */ var templates = (CollectionTemplate);

// EXTERNAL MODULE: ./src/modules/common/components/head/index.tsx
var head = __webpack_require__(63269);
// EXTERNAL MODULE: ./src/modules/layout/templates/index.tsx + 13 modules
var layout_templates = __webpack_require__(77092);
// EXTERNAL MODULE: ./src/modules/skeletons/templates/skeleton-collection-page/index.tsx
var skeleton_collection_page = __webpack_require__(31660);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/pages/akoestische-panelen/[id].tsx











var fetchCollection = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        config/* medusaClient.collections.retrieve */.pZ.collections.retrieve(id).then(function(param) {
                            var collection = param.collection;
                            return {
                                id: collection.id,
                                title: collection.title
                            };
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetchCollection(id) {
        return _ref.apply(this, arguments);
    };
}();
var fetchCollectionByHandle = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        config/* medusaClient.collections.list */.pZ.collections.list({
                            handle: [
                                id
                            ]
                        }).then(function(param) {
                            var collections = param.collections;
                            return {
                                id: collections[0].id,
                                title: collections[0].title
                            };
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetchCollectionByHandle(id) {
        return _ref.apply(this, arguments);
    };
}();
var __N_SSG = true;
var fetchCollectionProducts = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var _pageParam, pageParam, id, cartId, filters, data, ref, products, count, offset;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 0 : _pageParam, id = param.id, cartId = param.cartId, filters = param.filters;
                    data = {
                        limit: 12,
                        offset: pageParam,
                        collection_id: [
                            id
                        ],
                        cart_id: cartId
                    };
                    if (filters) data["id"] = Object.values(filters).reduce(function(acc, val) {
                        return acc.concat(val);
                    }, []);
                    return [
                        4,
                        config/* medusaClient.products.list */.pZ.products.list(data)
                    ];
                case 1:
                    ref = _state.sent(), products = ref.products, count = ref.count, offset = ref.offset;
                    return [
                        2,
                        {
                            response: {
                                products: products,
                                count: count
                            },
                            nextPage: count > offset + 12 ? offset + 12 : null
                        }
                    ];
            }
        });
    });
    return function fetchCollectionProducts(_) {
        return _ref.apply(this, arguments);
    };
}();
var CollectionPage = function(param) {
    var notFound = param.notFound, content = param.content;
    var ref = (0,router.useRouter)(), query = ref.query, isFallback = ref.isFallback, replace = ref.replace;
    var id = typeof query.id === "string" ? query.id : "";
    var ref1 = (0,es.useQuery)([
        "get_collection_handle",
        id
    ], function() {
        return fetchCollectionByHandle(id).then(function(collection) {
            return collection;
        }).catch(function() {
            return fetchCollection(id);
        });
    }), data = ref1.data, isError = ref1.isError, isSuccess = ref1.isSuccess, isLoading = ref1.isLoading;
    if (notFound) {
        if (constants/* IS_BROWSER */.Q) {
            replace("/404");
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_collection_page/* default */.Z, {
            content: content
        });
    }
    if (isError) {
        replace("/404");
    }
    if (isFallback || isLoading || !data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_collection_page/* default */.Z, {
            content: content
        });
    }
    if (isSuccess) {
        var ref2, ref3, ref4, ref5, ref6;
        var ref7, ref8, ref9, ref10;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(head/* default */.Z, {
                    title: (ref7 = content === null || content === void 0 ? void 0 : (ref2 = content.seo) === null || ref2 === void 0 ? void 0 : ref2.metaTitle) !== null && ref7 !== void 0 ? ref7 : data.title,
                    description: "".concat((ref8 = content === null || content === void 0 ? void 0 : (ref3 = content.seo) === null || ref3 === void 0 ? void 0 : ref3.metaDescription) !== null && ref8 !== void 0 ? ref8 : data.title),
                    image: (ref9 = content === null || content === void 0 ? void 0 : (ref4 = content.seo) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.metaImage) === null || ref5 === void 0 ? void 0 : ref5.url) !== null && ref9 !== void 0 ? ref9 : null,
                    canonical: (ref10 = content === null || content === void 0 ? void 0 : (ref6 = content.seo) === null || ref6 === void 0 ? void 0 : ref6.canonicalURL) !== null && ref10 !== void 0 ? ref10 : undefined
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(templates, {
                    collection: data,
                    content: content
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
CollectionPage.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_templates/* default */.Z, {
        children: page
    });
};
/* harmony default export */ var _id_ = (CollectionPage);


/***/ }),

/***/ 97650:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const observerMap = new Map();
const RootIds = new WeakMap();
let rootId = 0;
let unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== undefined).map(key => {
    return `${key}_${key === 'root' ? getRootId(options.root) : options[key]}`;
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  let id = optionsToId(options);
  let instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    const elements = new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  const {
    id,
    observer,
    elements
  } = createObserver(options); // Register the callback listener for this element

  let callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

const _excluded = (/* unused pure expression or super */ null && (["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"]));

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


class InView extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    this.node = null;
    this._unobserveCb = null;

    this.handleNode = node => {
      if (this.node) {
        // Clear the old observer, before we start observing a new element
        this.unobserve();

        if (!node && !this.props.triggerOnce && !this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          this.setState({
            inView: !!this.props.initialInView,
            entry: undefined
          });
        }
      }

      this.node = node ? node : null;
      this.observeNode();
    };

    this.handleChange = (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        this.unobserve();
      }

      if (!isPlainChildren(this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        this.setState({
          inView,
          entry
        });
      }

      if (this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        this.props.onChange(inView, entry);
      }
    };

    this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
  }

  componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }

  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }

  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
  }

  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  }

  render() {
    if (!isPlainChildren(this.props)) {
      const {
        inView,
        entry
      } = this.state;
      return this.props.children({
        inView,
        entry,
        ref: this.handleNode
      });
    }

    const _this$props = this.props,
          {
      children,
      as
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return React.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  }

}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  const unobserve = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView
  }); // Store the onChange callback in a `ref`, so we can access the latest instance inside the `useCallback`.

  callback.current = onChange;
  const setRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(node => {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, (inView, entry) => {
        setState({
          inView,
          entry
        });
        if (callback.current) callback.current(inView, entry);

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root,
        rootMargin,
        threshold,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      }, fallbackInView);
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  /* eslint-disable-next-line */

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  const result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.modern.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9128,3662,3415,1228,5445,5937,4617,6158,6556,3815,6659,2931,7092,1702,9774,2888,179], function() { return __webpack_exec__(58451); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);